import React from 'react';
import styles from './Benefit.module.scss';
import {PanelInfo} from "./components/panel-info/PanelInfo";
import {HomeBenefits} from "../../../../settings/data";
import img from './background.png';

export const Benefit = (props) => {
    return (
        <>
            <div style={{paddingTop: '1rem'}} id="benefit-section"/>
            <div className={styles.container} style={{backgroundImage: `url(${img})`}}>
                <div className={styles.infoContainer}>
                    <h1>
                        Beneficios de nuestros servicios
                    </h1>

                    <div className={styles.infoBody}>
                        {
                            HomeBenefits.map(feature => <PanelInfo {...feature} key={feature.title}/>)
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

Benefit.propTypes = {}

Benefit.defaultProps = {}

export default React.memo(Benefit);
